import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Button } from "antd";

import partnersApi from "../../../apis/Partners.api";
import { toastAlert } from "../../AlertComponent";

const CommentFavorite = ({ item, type }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const [isLike, setIsLike] = useState(false);
	const [count, setCount] = useState(false);
	// const [loading, setLoading] = useState()
	const loading = useRef(null);

	const favoriteBtn = {
		border: "none",
		boxShadow: "none",
		marginLeft: "auto",
		display: "flex",
		// flexDirection: "column",
		alignItems: "center",
		gap: "4px",
		backgroundColor: "inherit",
		padding: 0,
		position: "absolute",
		top: type === "reply" ? 0 : "1em",
		right: type === "reply" ? "-0.5em" : "1em",
		height: "auto",
	};

	useEffect(() => {
		if (item?.id) {
			getFavorite();
		}
	}, [item, cUser]);

	const getFavorite = async () => {
		const param = {
			id: item?.id,
			targetType: type,
			userId: cUser?.id ?? 0,
		};
		const res = await partnersApi.readCommentFavorite(param);
		if (res.code === 200) {
			setIsLike(res.result?.is_like);
			setCount(res.result?.like_num);
		}
	};

	const handleFavorite = (e) => {
		e.stopPropagation();
		if (cUser?.id) {
			if (isLike) {
				deleteFavorite();
			} else {
				addFavorite();
			}
		} else {
			toastAlert("로그인 후 이용 가능합니다.");
		}
	};

	const addFavorite = async () => {
		loading.current = true;
		if (!isLike) {
			const param = {
				user_id: cUser?.id,
				target_type: type,
				target_id: item?.id,
				influencer_id: reduxChannel?.user_id,
			};
			const res = await partnersApi.addFavoriteHistory(param);
			if (res.code === 200) {
				setIsLike(true);
				getFavorite();
			}
		}
		loading.current = false;
	};

	const deleteFavorite = async () => {
		loading.current = true;
		if (isLike) {
			const param = {
				userId: cUser?.id,
				targetType: type,
				targetId: item?.id,
				influencer_id: reduxChannel?.user_id,
			};
			const res = await partnersApi.deleteFavoriteHistory(param);
			if (res.code === 200) {
				setIsLike(false);
				getFavorite();
			}
		}
		loading.current = false;
	};

	return (
		<Button
			style={favoriteBtn}
			// onDoubleClick={() => setIsLike(!isLike)}
			onClick={handleFavorite}
			disabled={loading.current}
		>
			<p
				style={{
					fontSize: "0.9em",
					color: "#6d7580",
					lineHeight: 1.6,
				}}
			>
				{count}
			</p>
			<img
				src={`/assets/images/channel/favorite-${isLike ? "on" : "off"}.png`}
				alt={`댓글 좋아요 아이콘`}
				style={{
					width: "1em",
					height: "1em",
				}}
			/>
		</Button>
	);
};
export default CommentFavorite;
